import * as React from 'react';

import { Notification } from 'farmhub-ui-core';

import { useAppDispatch, useAppSelector } from 'app';
import { findCertification, selectAppDevice } from 'slice';
import { DEVICES } from 'utils';

import SelectCertificatesStepDesktop from './SelectCertificatesStepDesktop';
import SelectCertificatesStepMobile from './SelectCertificatesStepMobile';

interface SelectCertificatesProps {
  data: any;
  setData: (e: any) => void;
}

const SelectCertificatesStep = ({
  data,
  setData,
}: SelectCertificatesProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const appDevice = useAppSelector(selectAppDevice);

  const certificationList = useAppSelector(state => state.certification.list);

  const [isLoadingCertification, setIsLoadingCertification] =
    React.useState(false);

  const handleClickCertifications = id => {
    if (data.certificationIDs.includes(id)) {
      const newArr = data.certificationIDs.filter(item => item !== id);
      setData({ ...data, certificationIDs: newArr });
    } else {
      const newArr = data.certificationIDs.concat(id);
      setData({ ...data, certificationIDs: newArr });
    }
  };

  const handleSelectAllOrDeleteCertificates = () => {
    setData((prevState: any) => {
      if (prevState.certificationIDs.length > 0) {
        return { ...prevState, certificationIDs: [] };
      }
      return {
        ...prevState,
        certificationIDs: certificationList.map(item => item.id),
      };
    });
  };

  React.useEffect(() => {
    const initCertification = async () => {
      setIsLoadingCertification(true);
      try {
        await dispatch(findCertification()).unwrap();
      } catch (error: any) {
        Notification('error', 'Tải chứng chỉ thất bại', error);
      }
      setIsLoadingCertification(false);
    };

    initCertification();
  }, [dispatch]);

  const renderElements = {
    [DEVICES.DESKTOP]: (
      <SelectCertificatesStepDesktop
        data={data}
        handleClickCertifications={handleClickCertifications}
        handleSelectAllOrDeleteCertificates={
          handleSelectAllOrDeleteCertificates
        }
        isLoadingCertification={isLoadingCertification}
      />
    ),
    [DEVICES.MOBILE]: (
      <SelectCertificatesStepMobile
        data={data}
        handleClickCertifications={handleClickCertifications}
        handleSelectAllOrDeleteCertificates={
          handleSelectAllOrDeleteCertificates
        }
        isLoadingCertification={isLoadingCertification}
      />
    ),
    [DEVICES.TABLET]: (
      <SelectCertificatesStepMobile
        data={data}
        handleClickCertifications={handleClickCertifications}
        handleSelectAllOrDeleteCertificates={
          handleSelectAllOrDeleteCertificates
        }
        isLoadingCertification={isLoadingCertification}
      />
    ),
  };

  return <>{renderElements[appDevice.device]}</>;
};

export default SelectCertificatesStep;
